// extracted by mini-css-extract-plugin
export default {"typographyWidth":"NjHCM50Gpy2sCMka01vM","tooltipWidth":"CkXJGdv_ZS2IBF2XIEo3"};